/**
 * This function is to cover the use case when we need to override the game state base label.
**/

import getTranslation from 'bdata-sns-shared/utils/getTranslation';
import GameStateTypes from 'bdata-sns-shared/game/types/GameStateTypes';

const overrideGameStateLabel = (options) => {
    const {
        gameState,
        isPostponed,
        isCancelled,
        dictionary,
        currentInning,
        scheduledInnings,
        perfectGame,
        noHitter,
        isWarmup
    } = options;

    let infoText;
    let extraInningsSuffix;
    const isNotableGame = (perfectGame || noHitter);

    switch (gameState) {
    case GameStateTypes.LIVE:
        if (isWarmup) {
            infoText = '';
            return infoText;
        }

        return infoText;
    case GameStateTypes.FINAL:
        /**
         * when game is cancelled and not postponed and is a notable game with extra innings
         * we want to show inning state on mobile differently.
         * everything else should just return a emptry string
        **/

        extraInningsSuffix = (typeof currentInning !== 'undefined' && typeof scheduledInnings !== 'undefined' && currentInning !== scheduledInnings) ? `/${currentInning}` : '';

        if (!isCancelled && !isPostponed && isNotableGame && extraInningsSuffix) {
            infoText = `${getTranslation(dictionary, 'game_status_final_abbrevl', 'F')}${extraInningsSuffix}`;
            return infoText;
        } else if (isCancelled) {
            infoText = '';
            return infoText;
        } else if (isPostponed) {
            infoText = '';
            return infoText;
        }

        return infoText;
    default: return infoText;
    }
};

export default overrideGameStateLabel;
